import { EVerificationStatus, IContactDetailsState } from '../initialState';

export const selectIsPhoneConfirmed = (state: IContactDetailsState): boolean => {
    const {
        contactDetails: {
            editedPhone,
            confirmedPhone,
        },
    } = state;

    if (!editedPhone) {
        return false;
    }

    return confirmedPhone.status === EVerificationStatus.verified && editedPhone === confirmedPhone.phone;
};
